module.exports = __webpack_public_path__ + "static/media/perl.4aea0935.svg";